import requests from "./api/base-api";

const FcmService = {

    PushToken: (body) => requests.post(`/fcm/v1/save-push-token-user`, body),
};

export default FcmService;